"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldsetContextProvider = exports.Consumer = exports.FieldsetContextConsumer = exports.FieldsetContext = exports.defaultFieldsetContext = void 0;

var _react = require("react");

var defaultFieldsetContext = {
  disabled: false,
  size: 'default'
};
exports.defaultFieldsetContext = defaultFieldsetContext;
var FieldsetContext = (0, _react.createContext)(defaultFieldsetContext);
exports.FieldsetContext = FieldsetContext;
var Consumer = FieldsetContext.Consumer,
    Provider = FieldsetContext.Provider; // Used downstream in FileManagerUI

exports.FieldsetContextProvider = Provider;
exports.Consumer = exports.FieldsetContextConsumer = Consumer;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/context/FieldsetContext.js
// module id = 131
// module chunks = 5 6